import { render, staticRenderFns } from "./PhotographyDeliveryShell.vue?vue&type=template&id=634af6e8&scoped=true&"
import script from "./PhotographyDeliveryShell.vue?vue&type=script&lang=js&"
export * from "./PhotographyDeliveryShell.vue?vue&type=script&lang=js&"
import style0 from "./PhotographyDeliveryShell.vue?vue&type=style&index=0&id=634af6e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634af6e8",
  null
  
)

export default component.exports